import $ from 'jquery';
import Theme from './front-components/theme';
//import * as bootstrap from 'bootstrap'; // full bootstrap
import Collapse from 'bootstrap/js/dist/collapse'


require('./front-components/main');

$(document).ready(() => {
	window.RS = new Theme();
});
